<template>
    <div>
        <div class="text-center text-14 text-a-brown-502314" v-if="serialModel.redeemTimestamp != ''">
            {{lbl.serial.redeem_on}} {{getRedeemDate(serialModel.redeemTimestamp)}}
        </div>
        <div v-if="serialModel.showTimer" class="text-18 text-a-red-d62300 text-center font-bold mt-2">
            <div v-if="!isTimeExpired">
                {{lbl.serial.expire_in}} {{displayTime}}{{lbl.serial.min}}
            </div>
            <div v-else>
                {{lbl.serial.code_expired}}
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import TimerHelper from '@/helper/TimerHelper.js';
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "SerialTimer",
    mixins: [LocaleMixin],
    props: {
        serialModel: Object,
    },
    data: function () {
        return {
            timer: new TimerHelper(),
            displayTime: "",
            isTimeExpired: false,
        };
    },
    created: function () {
        Util.log('serial timer', this.serialModel);
        this.initial();
    },
    beforeUnmount: function() {
        if (this.timer.interval) {
            this.timer.stopTimer();
        }
    },
    methods: {
        initial: function () {
            if (this.timer.interval) {
                this.timer.stopTimer();
            }

            this.timer.initialTimer(this.serialModel.expireIn,".");
            if (this.serialModel.showTimer) {
                this.isTimeExpired = false;
                this.timer.runTimer((display) => {
                    this.displayTime = display;
                }, () => {
                    this.isTimeExpired = true;
                    this.serialExpired();
                });
            }
        },
        serialExpired: function () {
            this.$emit("onSerialExpired");
        },
        getRedeemDate: function (redeemDate) {
            // redeemDate add 7 hours return timestamp
            
            return DatetimeHelper.dateCustomFormat(redeemDate,7) + " - " + DatetimeHelper.timeCustomFormat(redeemDate,7);
        },
    }
}
</script>
<style lang="scss" scoped>

</style>
